import { render, staticRenderFns } from "./MonthGasRecord.vue?vue&type=template&id=a50e3f4c&"
import script from "./MonthGasRecord.vue?vue&type=script&lang=js&"
export * from "./MonthGasRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports